// extracted by mini-css-extract-plugin
export default {"keyFeaturesContainer":"KeyFeatures_keyFeaturesContainer__91gAF","keyCardContainer":"KeyFeatures_keyCardContainer__uxp0e","keyCard":"KeyFeatures_keyCard__ngwVF"};